export const validRefundAmount = (amount: number, total: number) =>
  Number.isFinite(amount) && amount > 0 && amount <= total &&
  Math.abs(amount * 100 - Math.round(amount * 100)) < 0.000001;

export const refundStorageKey = (orderId: number, full: boolean, amount: number) =>
  `epos.refund:${orderId}:${full ? "full" : Math.round(amount * 100)}`;

// Preserve identity through timeouts, modal reopen and browser reload. Only an
// acknowledged terminal response may release it for a separate partial refund.
export const refundRequestKey = (storageKey: string) => {
  const existing = window.localStorage.getItem(storageKey);
  if (existing) return existing;
  const id = window.crypto.randomUUID();
  window.localStorage.setItem(storageKey, id);
  return id;
};
